import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { stages } from '../../occupation-of-lane-placement-construction-objects.routes';
import {
  OccupationOfLanePlacementConstructionObjectsStatementForm
} from './forms/occupation-of-lane-placement-construction-objects-statement.form';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { AlertComponent } from '../../../../../../common/alert/alert.component';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateApplication } from '../../../../../../store/actions/application.actions';

@Component({
  selector: 'app-occupation-of-lane-placement-construction-objects-statement-section',
  standalone: true,
  imports: [
    StagesComponent,
    ReactiveFormsModule,
    CommonModule,
    SpinnerComponent,
    AlertComponent
  ],
  providers: [OccupationOfLanePlacementConstructionObjectsStatementForm],
  templateUrl: './occupation-of-lane-placement-construction-objects-statement-section.component.html'
})
export class OccupationOfLanePlacementConstructionObjectsStatementSectionComponent implements OnDestroy {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public stages: string[] = stages;

  public form: OccupationOfLanePlacementConstructionObjectsStatementForm = inject(OccupationOfLanePlacementConstructionObjectsStatementForm);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.value,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../oplaty'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
